<template>
    <div>
        <v-dialog
            v-model="successOverlayDialog"
            content-class="success-con"
            :overlay-opacity="opacity"
            :hide-overlay="true"
            :persistent="true"
        >
            <div class="create-ad-card flex">
                <div class="mid-con">
                    <img src="../../../../assets/tickMark.svg" alt="" />
                    <h3>Your campaign has been {{type}} successfully</h3>
                </div>
                <v-btn
                    @click="handleClose"
                    color="#EBF5F0"
                    class="close-btn"
                    elevation="0"
                    x-large
                >
                    Close
                </v-btn>
            </div>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: "success-page",
    data() {
        return {
            opacity: 0,
            successOverlayDialog: this.successOverlay,
        };
    },
    watch: {
        successOverlay: function () {
            this.successOverlayDialog = this.successOverlay;
        },
    },
    props: {
        successOverlay: Boolean,
        type: String,
    },
    methods: {
        handleClose() {
            this.$emit("closeAll");
        },
    },
};
</script>

<style lang="scss" scoped>
.create-ad-card {
    height: 650px;
    padding: 30px 30px 12px;
    color: #333333;
    flex-direction: column;
}
.mid-con {
    width: 100%;
    height: 82%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
        width: 18%;
        margin-bottom: 20px;
    }
    h3 {
        font-size: 1.4rem;
        font-weight: 500;
    }
}
.v-btn {
    height: 60px !important;
}
.close-btn {
    color: #1d8d56;
    font-weight: 600;
    text-transform: capitalize;
    font-size: 1.2rem;
    width: 100%;
    font-size: 1.2rem;
}
</style>

<style>
.success-con.v-dialog {
    width: 800px;
    background-color: white;
    border-radius: 10px;
    box-shadow: none;
}
</style>